"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHifiLandingLinkClick = void 0;
/**
 * A builder for HifiLandingLinkClick
 *
 * @param data - The event data
 * @return The formatted event data for HifiLandingLinkClickEvent
 */
function createHifiLandingLinkClick(data) {
    return {
        name: 'HifiLandingLinkClick',
        environments: ['browser'],
        data: data,
    };
}
exports.createHifiLandingLinkClick = createHifiLandingLinkClick;
//# sourceMappingURL=createHifiLandingLinkClick.js.map